<div class="eService-panel">
    <div class="eService-panel-row">
        <h1 class="service_details_title new22"> {{item.name}} &nbsp;</h1>


        <div class="hidden-xs">

            <span style="display: none;" id="serviceURL">
                <a
                    href="https://eservices.zatca.gov.sa/sites/sc/ar/gebaya/Pages/default.aspx">https://eservices.zatca.gov.sa/sites/sc/ar/gebaya/Pages/default.aspx</a>
            </span>
        </div>
    </div>



    <div class="serviceTaxTypes">
        <div [routerLink]="'/all-data-view'" [queryParams]="{id: item.ministry.id}"
            class="minisbuttontax tax-1">
            <img *ngIf="checkisImg(item.ministry.icon); else elseBlock"
                        src="{{staticURL}}{{item.ministry.icon}}" class="img-fluid"
                        style="max-height: 30px; max-width: 30px;">
                    <ng-template #elseBlock>
                        <i class="{{item.ministry.icon}} p-2" style="font-size: 1rem;"></i>
                    </ng-template>
                    <p class="px-1">{{item.ministry.label}}</p>
        </div>
                
    </div>

    <div class="service-desc mb-10 p-2" [innerHTML]="data.data | safeHTML"></div>

    <div class="duration d-flex align-items-center" >
        <!-- <img style="max-width: 60px;" class="m-5" src="../../../../assets/single/calendar.svg" alt="MobileApp"> -->
        <i class="pi pi-calendar m-5" style="
        font-size: 2.2rem;
        color: white;
    "></i>
        <div>
            <h5 style="color: white;">
                {{"Last updated" | translator}}
            </h5>

            <p class="v4-color-white">{{item.updatedAt |
                date:'MMMM d, y'}}</p>
        </div>

    </div>
</div>